import React from "react";
import { Link } from "react-router-dom";
import { Youtube } from "lucide-react";

const YT_URL = "https://www.youtube.com/@thespiritualseekerchannel";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-tattva-ornament bg-tattva-bg mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <div className="flex items-baseline gap-2">
                        <span className="font-serif text-2xl text-tattva-ink">
                            Tattva
                        </span>
                        <span className="font-display text-base text-tattva-terracotta">
                            तत्त्व
                        </span>
                    </div>
                    <p className="text-sm text-tattva-muted mt-4 max-w-sm leading-relaxed">
                        A contemplative home for Hindu festivals, shlokas, and
                        the science of sacred ritual.
                    </p>
                </div>
                <div>
                    <p className="text-xs uppercase tracking-[0.22em] text-tattva-muted mb-4">
                        Explore
                    </p>
                    <ul className="space-y-2 text-sm text-tattva-ink">
                        <li>
                            <Link
                                to="/videos"
                                className="hover:text-tattva-terracotta"
                            >
                                Videos
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/calendar"
                                className="hover:text-tattva-terracotta"
                            >
                                Festival Calendar
                            </Link>
                        </li>
                        <li>
                            <a
                                href={YT_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open(
                                        YT_URL,
                                        "_blank",
                                        "noopener,noreferrer",
                                    );
                                }}
                                data-testid="footer-youtube-link"
                                className="inline-flex items-center gap-2 hover:text-tattva-terracotta cursor-pointer"
                            >
                                <Youtube size={16} strokeWidth={1.6} /> The
                                Spiritual Seeker — YouTube
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <p className="text-xs uppercase tracking-[0.22em] text-tattva-muted mb-4">
                        A Note
                    </p>
                    <p className="font-serif italic text-tattva-ink text-lg leading-snug">
                        “The whole world is one family.”
                    </p>
                    <p className="font-display text-tattva-terracotta text-xl mt-1">
                        वसुधैव कुटुम्बकम्
                    </p>
                </div>
            </div>
            <div className="border-t border-tattva-ornament">
                <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 flex items-center justify-between text-xs text-tattva-muted">
                    <span>© {new Date().getFullYear()} Tattva</span>
                    <span className="uppercase tracking-[0.22em]">
                        Made with reverence
                    </span>
                </div>
            </div>
        </footer>
    );
}
